import React, { FC } from 'react';
import { QRCode as BaseQrCode, QRCodeProps } from 'antd';

const QrCode: FC<QRCodeProps> = ({
  type = 'svg',
  size = 180,
  bordered = false,
  ...props
}) => (
  <BaseQrCode
    type={type}
    size={size}
    bordered={bordered}
    {...props}
  />
);

export default QrCode;
